(function () {
    'use strict';

    angular
        .module('app')
        .controller('UserProfilePopupController', UserProfilePopupController);

        UserProfilePopupController.$inject = ['$state', '$scope', '$http', '$rootScope'];

        function UserProfilePopupController($state, $scope, $http, $rootScope) {
            var vm = this;
            vm.state = $state;
            vm.closePopup = closePopup;
            vm.goToBand = goToBand;
            vm.goToSpace = goToSpace;
            vm.band_count = 0;
            vm.space_count = 0;

            $scope.$watch('vm.show', function () {
                if(vm.show){
                    getUserProfileData();
                }
            });

            function getUserProfileData(){
                return $http.get('api/users/user_public/' + vm.user + '/')
                    .then(function (response) {
                        vm.profile_user = response.data;
                        if(vm.profile_user.affiliates.band){
                            vm.band_count = vm.profile_user.affiliates.band.length;
                        }
                        if(vm.profile_user.affiliates.space){
                            vm.space_count = vm.profile_user.affiliates.space.length;
                        }
                        vm.profile_count = vm.band_count + vm.space_count;
                        vm.data_loaded = true;
                    });
            }

            function closePopup() {
                vm.show = 0;
            }

            function goToSpace(space_slug){
                $state.go('host', {space_slug: space_slug});
            }

            function goToBand(band_slug){
                $state.go('musician', {band_slug: band_slug});
            }
        }
})();

